import clsx from 'clsx'
import {take, range, partial} from 'lodash'
import moment from 'moment'
import React from 'react'
import Text from 'react-text'
import {Consumer} from '../../context'
import {deleteEvent} from '../../context/post'
import Toolbar from './toolbar'
import Filters from './filters'
import Label from '../label'
import confirmDialog from '../confirm-dialog'
import EditSchedule from '../edit-schedule'
import UpdateAssignment from '../quiz/content/update-assignment'
import EditStudentAssignment from '../quiz/content/EditStudentAssignment'
import create from '../../helpers/command'

import { homeworkColor, assessmentColor } from './event'

import './day.styl'

import DeleteHomework from 'teacher/homework/components/delete-homework'

function eventTitle({translate}, {type, content, title}) {
  switch (type) {
    case 'comment': return translate('comment')
    case 'uploaded': return content.title
    case 'a.assignment': return content.title
    case 'schedule': return title
    default: return title
  }
}

function eventContent({type, content, title}) {
  switch (type) {
    case 'comment': return content.message
    case 'uploaded': return content.title
    case 'a.assignment': return content.title
    case 'schedule': return title
    default: return title
  }
}

function Event (props) {


  const {context, group} = props
  const isAssessment = ['quiz', 'a.assignment'].indexOf(props.type) >= 0
  const isHomework = props.type == 'homework'
  const subjectId = group ? group.course.substring(0,2) : undefined
  const subject = context.subjects.find(subject => subject.id == subjectId)
  const isEditing = context.event == props.id
  const canDelete = isAssessment
    ? props.content.startedCount < 1
    : true 
  const bandColor = isAssessment
    ? assessmentColor
    : isHomework
      ? homeworkColor
      : subject.color

  return (
    <div className="schedule-event">
      {subject && (
        <div className="group">
          <div className="color-band" style={{backgroundColor: bandColor}} />
          <div className="title">
            <div className="subject">
              {`${group.subject} - ${group.grade}`}
            </div>
            <div className="name">
              <label title={group.name}>{group.name}</label>
            </div>
          </div>
        </div>
      )}
      <div className="content">
        {eventContent(props)}
      </div>
      <div className="actions-wrapper">
        <div className="actions">
          { isEditing && group && (
            <EditSchedule
              title={eventTitle(context, props)}
              eventTitle={props.title}
              content={props.content}
              message={props.content.message}
              start={props.start}
              finish={props.end}
              date={moment(props.start).toDate()}
              selectedStudents={
                group
                .students
                .filter(student => props.students.indexOf(student.id) >= 0)
                .map(student => ({...student, selected: true}))
              }
              studentList={
                group
                .students
                .filter(student => props.students.indexOf(student.id) < 0)
                .map(student => ({...student, selected: false}))
              }
              selectedGroup={group}
              activeTab='groups'
            />)}
          <div
            className="action edit"
            onClick={async () => {
              const action = props.content.linked ? 'schedule' : 'posts'
              if (props.type != 'quiz' && !isHomework) return context.navigate({action, event: props.id},'/:languageId/:role/:page/day/:action/:event', {preserveQuery: true})
              if (isAssessment) {
                const assignment = await fetchAssignment(props.id)
                if (!assignment) return
                const dialog = assignment.startedCount > 0 ? 'edit-student-assignment' : 'edit-assignment'
                context.updateState({quizAssignmentToModify: {$set: assignment}, quizDialogs: {[dialog]: {$set: true}}})
              }
              if (isHomework) {
                context.updateState({homeworkContext: {review: {from: {$set: context.match.url}, query: {$set: context.query}}}})
                context.navigate({page: 'homework', id: props.id}, '/:languageId/:role/:page/:id')
              }
            }}
          >
            <Text id="edit_label" />
          </div>
          <div
            className={clsx('action', 'delete', {disabled: !canDelete})}
            onClick={ async () => {
              if (isHomework) {
                const homework = await fetchHomework(props.id)
                context.updateState({
                  homeworkContext: {
                    deleteHomework: {
                      open: {$set: true},
                      homework: {$set: homework}
                    }
                  }
                })
                return 
              }
              if (!canDelete) return
              confirmDialog({
                className: 'delete-schedule',
                translate: context.translate,
                children: (
                  <div className="message">
                    <div className="question">
                      {context.translate('confirm_delete_item')}
                    </div>
                    <div className="title">
                      {eventContent(props)}
                    </div>
                  </div>
                ),
                onConfirm: async () => {
                  if (props.type == 'quiz') {
                    const assignment = await fetchAssignment(props.id)
                    if (assignment && assignment.startedCount < 1)
                      await create('quiz', 'deleteAssignment')({id: props.id})
                  } else {
                    await deleteEvent(props.id)
                  }
                  const eventUpdates = props.context.eventUpdates + 1
                  props.context.setState({eventUpdates})
                }
              })
            }}
          >
            <Text id="delete_label" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default function DayView (props) {

  const {date} = props

  return (<Consumer>{ context => {
    const {groups, query, action, location} = context

    const events = context.events
      .map(event => {
        const group = groups.find(group => group.id == event.group)
        return {
          ...event,
          context,
          group,
          date
        }
      })
      .map((props,i) => (<Event key={i} {...props}/>))

    return (
      <div className="calendar day view">
        <Toolbar {...props} />
        <div className="calendar">
          <Filters />
          <DeleteHomework onDelete={() => {
            context.updateState({eventUpdates: {$apply: i => i + 1}})
          }} />
          <EditStudentAssignment context={context} />
          <UpdateAssignment context={context} />
          <div className="schedule-events">
            {events}
          </div>
        </div>
      </div>
    )}}</Consumer>)
}

async function fetchAssignment(id) {
  const [paging, results] = await create('quiz', 'searchAssignments')({id})
  if (paging.recordCount < 1) return false
  const [assignment] = results
  return assignment
}

async function fetchHomework(id) {
  const [homework] = await create('homework', 'getHomeworks')({id})
  return homework ? homework : false
}